import { createSlice } from "@reduxjs/toolkit";

export const themeSlice = createSlice({
  name: "theme",
  initialState: {
    darkTheme: JSON.parse(localStorage.getItem("theme")) === "true",
  },
  reducers: {
    toggleTheme: (state) => {
      state.darkTheme = !state.darkTheme;
      localStorage.setItem("theme", state.darkTheme);
    },
    setTheme: (state, theme) => {
      state.darkTheme = theme.payload;
      localStorage.setItem("theme", state.darkTheme);
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;

export default themeSlice.reducer;
